import { render, staticRenderFns } from "./RequestHistoryActions.vue?vue&type=template&id=8e995928&scoped=true&"
import script from "./RequestHistoryActions.vue?vue&type=script&lang=js&"
export * from "./RequestHistoryActions.vue?vue&type=script&lang=js&"
import style0 from "./RequestHistoryActions.vue?vue&type=style&index=0&id=8e995928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e995928",
  null
  
)

component.options.__file = "RequestHistoryActions.vue"
export default component.exports